module.exports = __webpack_public_path__ + "static/media/cube.9bc9a1e5.png";